/*
  YZIA — méga-menu au survol (desktop + souris), animation déroulé RÉVERSIBLE + RÉPÉTABLE.

  Le contenu d'un <details> fermé est en display:none → on ne peut pas transitionner depuis là.
  Cycle :
   - OUVERTURE : on pose [open] (rend le contenu), on force un reflow (l'état "enroulé" est pris
     en compte), puis on ajoute .facil-open → la transition CSS déroule. Rejouable à chaque survol.
   - FERMETURE : on retire .facil-open → la transition ré-enroule (contenu encore rendu),
     puis on retire [open] APRÈS l'anim → masque proprement.
  Tactile / clavier : <details> natif conservé ; l'event `toggle` synchronise .facil-open.
  Dawn garde la fermeture sur Échap / focusout / clic extérieur.
*/
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  var menus = document.querySelectorAll('header-menu > details.mega-menu');
  if (!menus.length) return;

  var CLOSE_MS = 450; // ≈ durée de la transition de ré-enroulement (clip-path 0.42s)

  function snapClose(except) {
    menus.forEach(function (d) {
      if (d !== except) {
        d.classList.remove('facil-open');
        d.removeAttribute('open');
      }
    });
  }

  menus.forEach(function (details) {
    var host = details.closest('li') || details;
    var content = details.querySelector('.mega-menu__content');
    var summary = details.querySelector('summary');
    var closeTimer;

    function reveal() {
      clearTimeout(closeTimer);
      snapClose(details);
      details.setAttribute('open', '');
      if (content) void content.offsetHeight; // reflow → la transition part de l'état enroulé
      details.classList.add('facil-open');
    }

    function conceal() {
      clearTimeout(closeTimer);
      details.classList.remove('facil-open'); // ré-enroulement (contenu encore rendu via [open])
      closeTimer = setTimeout(function () {
        details.removeAttribute('open');
      }, CLOSE_MS);
    }

    host.addEventListener('mouseenter', function () {
      if (mq.matches) reveal();
    });
    host.addEventListener('mouseleave', function () {
      if (mq.matches) conceal();
    });

    // Souris desktop : le clic ne doit pas re-toggler ce que le survol pilote.
    // Clavier (Entrée, e.detail === 0) : on laisse le <details> natif basculer.
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (mq.matches && e.detail !== 0) e.preventDefault();
      });
    }

    // Synchronise .facil-open avec l'état réel (clavier, clic extérieur, fermeture par Dawn).
    details.addEventListener('toggle', function () {
      if (details.open) {
        if (content) void content.offsetHeight;
        details.classList.add('facil-open');
      } else {
        details.classList.remove('facil-open');
      }
    });
  });

  // Repli desktop -> mobile : on referme tout.
  mq.addEventListener('change', function (e) {
    if (!e.matches) snapClose(null);
  });
})();
